import React from 'react';

interface Props {
  name: string;
  fileUrl: string;
  handleFile: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

function FileUpload({ name, fileUrl, handleFile }: Props) {
  return (
    <>
      <input type="file" name={name} onChange={handleFile} />
      {fileUrl && (
        <div
          css={{
            width: '160px',
            height: '160px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#f5f5f5',
            borderRadius: '20px',
            userSelect: 'none',
          }}
        >
          <img src={fileUrl} alt={name} width={120} />
        </div>
      )}
    </>
  );
}

export default FileUpload;
